var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFilledLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699ZM12.9165 10.6253H8.5915L10.0248 12.0587C10.2665 12.3003 10.2665 12.7003 10.0248 12.942C9.89984 13.067 9.7415 13.1253 9.58317 13.1253C9.42484 13.1253 9.2665 13.067 9.1415 12.942L6.6415 10.442C6.39984 10.2003 6.39984 9.80033 6.6415 9.55866L9.1415 7.05866C9.38317 6.81699 9.78317 6.81699 10.0248 7.05866C10.2665 7.30033 10.2665 7.70033 10.0248 7.94199L8.5915 9.37533H12.9165C13.2582 9.37533 13.5415 9.65866 13.5415 10.0003C13.5415 10.342 13.2582 10.6253 12.9165 10.6253Z",
    fill: "#686C81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFilledLeft);
export default __webpack_public_path__ + "static/media/arrow-filled-left.0fc1440fe2180efc43b85ffd7c1421b6.svg";
export { ForwardRef as ReactComponent };